import React, { useEffect } from 'react';

import {
  Box, Grid, Typography,
} from '@mui/material';

import { isEmpty } from 'lodash';

import {
  TextInput,
  required,
} from 'react-admin';

import { useFormContext, useWatch } from 'react-hook-form';

import ArrayInput from './base/ArrayInput';
import cleaner from '../../../utilities/dataProvider/cleaner';

const TaxResidencyDialogBody = () => (
  <Grid container columnSpacing={6}>
    <Grid size={12}>
      <TextInput fullWidth source="taxResidency" label="Tax residency" />
    </Grid>
  </Grid>

);

const ItemLabel = ({ value } : {value: Record<string, string>}) => {
  if (isEmpty(value)) return null;

  return (
    <Box display="flex" alignItems="center" gap={5}>
      <Typography
        variant="h6"
        color="primary.main"
      >
        {value.taxResidency}
      </Typography>
    </Box>
  );
};

const TaxResidency = () => {
  const value = useWatch({ name: '_value' });
  const { setValue } = useFormContext();
  useEffect(() => {
    setValue('value', (value ?? []).flatMap((v: {taxResidency: string }) => v.taxResidency), { shouldDirty: true });
  }, [setValue, value]);

  return (
    <Grid container spacing={6}>
      <Grid size={12}>
        <Typography
          color="#646464"
          variant="h6"
          marginBottom={4}
        >
          Tax residency
        </Typography>
        <ArrayInput
          rootField="_value"
          title="Add tax residency"
          itemNameSource="taxResidency"
          ItemLabel={ItemLabel}
          DialogBody={TaxResidencyDialogBody}
          validate={required()}
          transformItemData={cleaner}
        />
      </Grid>
    </Grid>
  );
};

export default TaxResidency;
